import { CustomerProfilePage } from "@/components/CustomerProfilePage";

const CustomerProfile = () => {
  return <CustomerProfilePage />;
};

export default CustomerProfile;